function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M4.5 53.25C3.2595 53.25 2.25 52.2405 2.25 51C2.25 50.58 2.385 50.1555 2.6595 49.7025L27.942 8.0775C28.2435 7.581 28.911 6.75 30 6.75C31.089 6.75 31.7565 7.581 32.0565 8.0775L57.3375 49.7025C57.615 50.1555 57.75 50.58 57.75 51C57.75 52.2405 56.7405 53.25 55.5 53.25H4.5Z",
  fill: "#F7A8A8"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M30 7.5C30.7215 7.5 31.197 8.1045 31.416 8.466L44.0565 29.2785L56.697 50.091C56.901 50.4255 57 50.7225 57 51C57 51.8265 56.3265 52.5 55.5 52.5H4.5C3.6735 52.5 3 51.8265 3 51C3 50.7225 3.099 50.4255 3.3015 50.091L15.942 29.2785L28.5825 8.466C28.803 8.106 29.2785 7.5 30 7.5ZM30 6C28.8135 6 27.879 6.738 27.3015 7.6875C2.019 49.3125 27.3015 7.6875 2.019 49.3125C1.7175 49.809 1.5 50.3745 1.5 51C1.5 52.6575 2.8425 54 4.5 54C5.811 54 54.09 54 55.5 54C57.1575 54 58.5 52.6575 58.5 51C58.5 50.3745 58.2825 49.809 57.981 49.3125C32.6985 7.6875 57.981 49.3125 32.6985 7.6875C32.121 6.738 31.1865 6 30 6Z",
  fill: "#C74343"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M10.815 26.1645L11.223 25.491L3.04348 24.51L2.18848 25.9185L10.368 26.8995L10.815 26.1645Z",
  fill: "#36404D"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M18.7351 13.122L13.7611 6.86548L12.9316 8.23198L17.9056 14.49L18.7351 13.122Z",
  fill: "#36404D"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M14.2036 20.5829L14.9836 19.2989L8.42258 15.6539L7.64258 16.9379L14.2036 20.5829Z",
  fill: "#36404D"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M49.1851 26.1645L48.7771 25.491L56.9566 24.51L57.8116 25.9185L49.6321 26.8995L49.1851 26.1645Z",
  fill: "#36404D"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M41.2649 13.122L46.2389 6.86548L47.0684 8.23198L42.0944 14.49L41.2649 13.122Z",
  fill: "#36404D"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M45.7966 20.5829L45.0166 19.2989L51.5776 15.6539L52.3576 16.9379L45.7966 20.5829Z",
  fill: "#36404D"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M30 48C31.6569 48 33 46.6569 33 45C33 43.3431 31.6569 42 30 42C28.3431 42 27 43.3431 27 45C27 46.6569 28.3431 48 30 48Z",
  fill: "#36404D"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M30 21C28.3425 21 27 22.239 27 23.769C27 24.792 28.503 37.7265 28.5105 37.7805C28.599 38.4675 29.232 39 30 39C30.768 39 31.401 38.4675 31.4895 37.7805C31.497 37.7265 33 24.792 33 23.769C33 22.239 31.6575 21 30 21Z",
  fill: "#36404D"
});

const SvgAlert = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
};

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAlert, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/alert.7868d653.svg";
export { ForwardRef as ReactComponent };